import { render } from "./Star-icon.vue?vue&type=template&id=5078e87e"
import script from "./Star-icon.vue?vue&type=script&lang=js"
export * from "./Star-icon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__